import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
  HttpHandler,
} from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { AuthInterceptor } from './auth.interceptor';
import { CustomHttp } from './custom-http';
import { throwIfAlreadyLoaded } from './module-import-check';
import { SwUpdateMessageComponent } from './sw-update-message/sw-update-message.component';

export function httpFactory(handler: HttpHandler): CustomHttp {
  return new CustomHttp(handler);
}

@NgModule({
  imports: [SharedModule, HttpClientModule],
  declarations: [SwUpdateMessageComponent],
  providers: [
    { provide: HttpClient, useFactory: httpFactory, deps: [HttpHandler] },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  exports: [],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule,
  ) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
